module.exports = __webpack_public_path__ + "static/media/table.0b58a265.svg";